<div class="p-p-2">
	<span class="p-float-label">
		<p-dropdown appendTo="body" [options]="options" [(ngModel)]="selectionLanguage" [filter]="filter" [disabled]="disabled" (onChange)="onChange()">
			<ng-template let-item pTemplate="selectedItem">
				<span>{{item.label}}</span>
			</ng-template>
			<ng-template let-opt pTemplate="item">
				<div>
					<div> {{opt.label}}</div>
				</div>
			</ng-template>
		</p-dropdown>
		<label for="field-id">{{label|translate}}</label>
	</span>
</div>
